<script setup>
import { ref, computed, onMounted } from 'vue';
import Layout from "@/layouts/main.vue";
import PageHeader from "@/components/page-header";
import store from '../../state/store';

const title = ref('Camera Process');

const items = ref([
  {
    text: "Home",
  },
  {
    text: "Camera",
  },
  {
    text: "Process",
    active: true,
  },
]);

const cameraProcess = computed(() => store.state.camera.cameraProcess);

const cameraProcessDetails = computed(() => store.state.camera.cameraProcessDetails);

const loading = computed(() => store.state.globals.loading);

const active = ref(null);

const selectCameraProcess = async (cameraTypeId) => {
  try {
    await store.dispatch('camera/getCameraProcessDetails', cameraTypeId);
    active.value = cameraTypeId;
  } catch (err) {
    console.log(err);
  }
}

onMounted(async () => {
  await store.dispatch('camera/getCameraProcess');
})

</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-md-12 col-lg-4">
        <div class="card">
          <div class="card-header">
            <h4>Camera Process</h4>
            <div class="text-muted">Select the camera you want to process</div>
          </div>
          <div class="card-body">
            <b-overlay :show="loading">
              <b-list-group>
                <div v-for="item in cameraProcess" :key="item.id" :data-id="item.id">
                  <b-list-group-item tag="button" :active="item.id === active">
                    <div class="clearfix">
                      <span class="float-start">{{ item.name }}</span>
                      <button @click="selectCameraProcess(item.id)" v-if="item.process === 'manual'" class="float-end btn btn-sm btn-info">Select</button>
                      <span v-else-if="item.process === 'auto'" class="text-success float-end">Auto</span>
                    </div>
                  </b-list-group-item>
                </div>
              </b-list-group>
            </b-overlay>
          </div>
        </div>
      </div>
      <div class="col-md-12 col-lg-8">
        <b-overlay :show="loading">
          <div class="card">
            <div class="card-header mb-3" v-if="cameraProcessDetails">
              <h5>{{ cameraProcessDetails.name }}</h5>
              <div class="text-muted">Process: {{ cameraProcessDetails.process }}</div>
              <div class="text-muted">Folder: {{ cameraProcessDetails.folder }}</div>
              <div class="text-muted">File Setting: s3</div>
            </div>
            <div class="card-body">
              <div v-if="cameraProcessDetails" class="table-responsive table-card m-1">
                <table class="table table-nowrap">
                    <thead class="table-light">
                        <tr>
                            <th scope="col">Folder</th>
                            <th scope="col">Action</th>
                            <th scope="col">Mass Process</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="camera in cameraProcessDetails.cameras" :key="camera.id">
                            <td>
                              <span class="float-start text-break">{{ camera.location }}</span>
                            </td>
                            <td>
                              <button class="btn btn-info btn-sm mr-2">Select</button>
                              <button class="btn btn-danger btn-sm">Archived</button>
                            </td>
                            <td>
                              <div class="form-check mb-3">
                                <input class="form-check-input mr-2" type="checkbox" id="formCheck6">
                              </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
              </div>
              <div v-else>
                <div class="text-center">
                  <div class="row justify-content-center">
                    <div class="col-lg-9">
                      <h4 class="mt-4 fw-semibold">Camera Process Details</h4>
                      <p class="text-muted mt-3"> 
                        Find camera type on the left side with manual process and click the "Select" button to show more details here.
                      </p>
                    </div>
                  </div>
                  <div class="row justify-content-center mt-5 mb-2">
                    <div class="col-sm-7 col-8">
                      <img src="@/assets/images/file.png" alt="" class="img-fluid">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-overlay>
      </div>
    </div>
  </Layout>
</template>